import { moveOutScreendown, moveOutScreenUp, showAboutTextAnimation, translateAboutBtn, endCursorHoverLineAnimation, initGalleryPosition } from "./util";
import { getLoadedValue, revealCaroussel, getCanOpenProject, getIndexInFront, nextProject, previousProject } from "./threeScript";

import Router from "./Router";
const url = window.location.pathname
const router = new Router(url);

const canvas = document.querySelector(".webgl");
const loader_unit = document.getElementById('text-loader-unit');
const loader_decade = document.getElementById('text-loader-decade');
const loader_hundred = document.getElementById('text-loader-hundred');
const app = document.getElementById('app');
const loader = document.getElementById('loader');
const tb_qt_1 = document.getElementById('tb-qt-1');
const tb_qt_2 = document.getElementById('tb-qt-2');
const tb_qt_3 = document.getElementById('tb-qt-3');
//cursor variables
const cursor = document.getElementById('cursor');
const cursor_elt_1 = document.getElementById('cursor-elt-1');
const cursor_elt_2 = document.getElementById('cursor-elt-2');
const cursor_elt_3 = document.getElementById('cursor-elt-3');
const HEIGHT_LETTER_CELL = 70;
//details button
const detail_btn = document.getElementById('detail-btn');
const detail_section = document.getElementById('detail-section');
const detail_mf = document.getElementById('mf-details');
const detail_container = document.getElementById('details-container');

//detail_infos

const roleSpan = document.getElementById("role-span");
const stackSpan = document.getElementById("stack-span");
const typeSpan = document.getElementById("type-span");
const liveLink = document.getElementById("live-link");

//central elements
const central_elements = document.getElementById('central-elements');
const centralElementsContainer = document.getElementById('central-elements-container');

//get cols name

const col_1 = document.getElementById('ct-col-1');
const col_2 = document.getElementById('ct-col-2');
const col_3 = document.getElementById('ct-col-3');
const col_4 = document.getElementById('ct-col-4');
const col_5 = document.getElementById('ct-col-5');
const col_6 = document.getElementById('ct-col-6');
const col_7 = document.getElementById('ct-col-7');
const col_8 = document.getElementById('ct-col-8');
const col_9 = document.getElementById('ct-col-9');
const col_10 = document.getElementById('ct-col-10');
const col_11 = document.getElementById('ct-col-11');

// mobile close project btn
const btnCloseProjectMobile = document.getElementById('btn-close-project');

//main images
var img_mf_container = document.getElementById('img-mobile-food');
//Ajouter image pour nouveau projet
var img_rn_container = document.getElementById('img-retronews');
var img_anazir_container = document.getElementById('img-anazir');
var img_more_container = document.getElementById('img-more');

var list_main_images = [img_rn_container,img_mf_container, img_anazir_container, img_more_container];

const mainImgSection = document.getElementById("main-img-section");

//gallery
var gallery_container = document.getElementById('gallery-container');
var gallery_mf = document.getElementById('mf-gallery');
var img_mf_1 = gallery_mf.querySelector('.first');
var img_mf_2 = gallery_mf.querySelector('.second');
var img_mf_3 = gallery_mf.querySelector('.third');
var selector_1 = gallery_mf.querySelector('.selector-1');
var selector_2 = gallery_mf.querySelector('.selector-2');
var selector_3 = gallery_mf.querySelector('.selector-3');


const imgSelector1 = selector_1.querySelector('img');
const imgSelector2 = selector_2.querySelector('img');
const imgSelector3 = selector_3.querySelector('img');
const selectorList = [selector_1, selector_2, selector_3];
var outline_selected = document.getElementById("outline-selected");
var selected_translation = 0;
var canChangeGalleryImage = true;

//top button
var btn_back = document.getElementById("btn-back");
var btn_top = document.getElementById("btn-top");


var backClickfunction;




//about
const btnCloseAbout = document.getElementById('btn-close-about');
const btnOpenAbout = document.getElementById('btn-open-about');
const aboutSection = document.getElementById("about-section");
const btnAboutContainer = document.getElementById("btn-about-container");
var aboutIsOpen = false;
var aboutLineSelected = null;
const aboutMovableLetterHeight = 40;
//scroll
//var lastScrollTop = 0;

//bool
var cursorFollow = true;
var imageHover = true;
var inDetailPageDesktop = false;
//var canSwipe = true;
var canClose = false;

const centralTextListFunction = [  showRetronewsTextAnimation ,showManagerTextAnimation, showAnazirTextAnimation,showMobileFoodTextAnimation]

//back function

//project datas
var projectDataList = null;
async function loadJsonData() {
    try {
        const response = await fetch('data.json');
        const data = await response.json();
        projectDataList = Array.isArray(data) ? data : Object.values(data);
    } catch (error) {
        console.error('Error loading JSON:', error);
    }
}

loadJsonData()
/**
 * Creates a reversible smooth movement animation using CSS transforms
 * @param {HTMLElement} element - The element to move
 * @returns {Object} Animation controller
 */




const movableNamePositionTab = [[0, -1, 0, -1, -1, 0, -2, 1, -2, 1, 1, -2], [0, -1, 0, -1, -1, 0, -2, 0, -1, -1, -1, -1], [-1, 0, -1, 0, 0, -1, 0, 0, 0, 0, 0, 0]];

const movableJobPositionTab = [
    [0, -2, 0, 1, -2, 0, 0, 0, -1, -2, 0, 0, 0, 0, 0],

    [-1, -1, -2, 0, -1, 0, -2, -1, 1, 1, 1, 1, 1, 1, 1],
    [-2, 0, -1, -1, 0, -1, -1, 1, 1, 1, 1, 1, 1, 1, 1]];
const movableUsePositionTab = [
    [-1, 0, -1, -1, -3, 0, -1, 0, 0, 0],
    [0, -1, -3, 0, -1, -1, 0, -2, 1, -3],
    [-2, -3, -2, -3, 0, 1, -2, 1, -2, 1],
    [-4, -2, 0, -4, -3, -2, 1, -2, -2, 1],
    [-3, -3, -4, -2, -2, -1, 0, 1, 1, -3]
]

const movableContactPositionTab = [
    [-1, -1, 0],

]

const indexList = {
    "name": 0,
    "job": 0,
    "use": 0,
    "contact": 0,

}

const nameLine = document.getElementById("about-name");
const jobLine = document.getElementById("about-job");
const useLine = document.getElementById("about-use");


function centerFromTheTop(img) {
    img.style.transition = "none";
    moveOutScreenUp(img);
    img.style.transition = "transform 1s";
    img.style.transform = "translateY(0px)";
    //img.style.transition="none";
}
function centerFromTheBottom(img) {
    img.style.transition = "none";
    moveOutScreendown(img);
    img.style.transition = "transform 1s ";
    img.style.transform = "translateY(0px)";

    //img.style.transition="none";
}
function goTop(img) {

    moveOutScreenUp(img);
    // img.style.transition="none";
}
function goBottom(img) {

    moveOutScreendown(img);
    // img.style.transition="none";
}

//function to init col position
function initCol() {
    col_1.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -6 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -7 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
}
function allColEmpty() {
    col_1.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -6 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
}


//function to init image position
function initMainImages() {
    //img_mf_container.style.transform = "translate(100vw, 70vh)";
    //img_anazir_container.style.transform = "translate(60vw, -100%)";
    //img_more_container.style.transform = "translate(10vw, 100vh)";
}
function initBottomBtn() {
    detail_btn.style.transform = "translateY(-50px)";


}

function updateBackButtonListener() {
    // Always remove the old listener
    btn_top.removeEventListener('click', handleBackClick);
    // Add the new listener
    btn_top.addEventListener('click', handleBackClick);
}
function handleBackClick(event) {

    if (backClickfunction) {
        backClickfunction(event);
    }
}

function setCloseDetailBtnClick() {


    backClickfunction = () => {
        closeDetailFunction();
    };
    updateBackButtonListener();
}

const closeDetailFunction = () => {
    closeDetailAnimation();
};


updateBackButtonListener();

// Function to update the loader
function updateLoader(unit, ten, hundred) {

    loader_unit.textContent = `${unit}`;
    loader_decade.textContent = `${ten}`;
    loader_hundred.textContent = `${hundred}`;
}

// Function to simulate progress from 1 to 100 over 4 seconds

function rotate_tbqt() {
    tb_qt_1.animate({
        transform: "rotate(360deg)",
    }, { duration: 1000, easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_2.animate({
        transform: "rotate(-360deg)",
    }, { duration: 1000, easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_3.animate({
        transform: "rotate(360deg)",
    }, { duration: 1000, easing: "cubic-bezier(0, 0.30, 0.19, 1)" });


}
function reverse_rotate_tbqt() {
    tb_qt_1.animate({
        transform: "rotate(0)",
    }, { duration: 1000, easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_2.animate({
        transform: "rotate(0)",
    }, { duration: 1000, easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_3.animate({
        transform: "rotate(0)",
    }, { duration: 1000, easing: "cubic-bezier(0, 0.30, 0.19, 1)" });


}

function rotate_cursor(factor) {


    cursor_elt_1.style.transform = "rotate(" + 45 * factor + "deg)"
    cursor_elt_2.style.transform = "rotate(-" + 45 * factor + "deg)"
    cursor_elt_3.style.transform = "rotate(" + 45 * factor + "deg)"


}
function rotateCursorByAnim(initialRotation) {
    const angle = initialRotation += 360;
    cursor_elt_1.animate({
        transform: `rotate(${angle}deg)`
    }, { duration: 1000, easing: 'cubic-bezier(0, 0.30, 0.19, 1)' });
    cursor_elt_2.animate({
        transform: `rotate(-${angle}deg)`
    }, { duration: 1000, easing: 'cubic-bezier(0, 0.30, 0.19, 1)' });
    cursor_elt_3.animate({
        transform: `rotate(${angle}deg)`
    }, { duration: 1000, easing: 'cubic-bezier(0, 0.30, 0.19, 1)' });
}

function getCurrentRotation(elt) {
    const currentTransform = window.getComputedStyle(elt).transform;
    let currentRotation = 0;

    if (currentTransform !== 'none') {
        const values = currentTransform.split('(')[1].split(')')[0].split(',');
        const a = values[0];
        const b = values[1];
        currentRotation = Math.round(Math.atan2(b, a) * (180 / Math.PI));
    }
    return currentRotation;
}

function addCursorRotation(elt, deg) {
    const newRotation = currentRotation + deg;
    elt.style.transform = `rotate(${newRotation}deg)`;
}


function showNameAnimation() {
    col_1.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
}
function showWorkTextAnimation() {
    col_1.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + -6 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
}

function showMobileFoodTextAnimation() {

    col_1.style.transform = "translateY(" + 0 + "px)";
    col_2.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";

}
function showAnazirTextAnimation() {
    col_1.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -1 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -6 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    //rotate_tbqt();
}
function showManagerTextAnimation() {
    col_1.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + 0 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    //rotate_tbqt();
}
function showRetronewsTextAnimation() {
    col_1.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    col_2.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_3.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_4.style.transform = "translateY(" + -5 * HEIGHT_LETTER_CELL + "px)";
    col_5.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_6.style.transform = "translateY(" + -4 * HEIGHT_LETTER_CELL + "px)";
    col_7.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_8.style.transform = "translateY(" + -2 * HEIGHT_LETTER_CELL + "px)";
    col_9.style.transform = "translateY(" + -7 * HEIGHT_LETTER_CELL + "px)";
    col_10.style.transform = "translateY(" + -3 * HEIGHT_LETTER_CELL + "px)";
    col_11.style.transform = "translateY(" + 1 * HEIGHT_LETTER_CELL + "px)";
    //rotate_tbqt();
}









function closeDetailAnimation() {
    router.goForward("/").then(() => {
        router.inTransition = false;
    });;

}
function hideDetails() {
    const details_container = detail_mf.querySelector(".details-container");
    details_container.style.transform = "translateY(25px)";
}




function unPutMainImageFullScreen() {
    canvas.style.filter = "blur(0px)";
}
function showTBQT() {

    tb_qt_1.animate({
        transform: "rotate(0deg)",
        width: "275px"

    }, { duration: 1000, fill: "forwards", easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_2.animate({
        transform: "rotate(0deg)",
        width: "275px"
    }, { duration: 1000, fill: "forwards", easing: "cubic-bezier(0, 0.30, 0.19, 1)" });
    tb_qt_3.animate({
        transform: "rotate(0deg)",
        width: "275px"
    }, { duration: 1000, fill: "forwards", easing: "cubic-bezier(0, 0.30, 0.19, 1)" });

}
function majSelector() {
    selectorList.forEach((element, i) => {
        if (i === router.actualRoute.props.imgSelected - 1) {
            element.classList.add("selected")
        }
        else {
            element.classList.remove("selected");

        }
    });
}





function moveOutlineSelected(elt) {
    const position = elt.getBoundingClientRect();
    // const outline_rect = outline_selected.getBoundingClientRect();
    const outline_rect = document.querySelector(".selector-1").getBoundingClientRect();
    const target = position.top - outline_rect.top;

    outline_selected.style.transform = "translateY(" + (target) + "px)";
    selected_translation += target;
    majSelector();

}

function initAboutButtonHover() {
    btnAboutContainer.style.pointerEvents = "none"
    btnAboutContainer.addEventListener('mouseover', () => { mouseEnterBtnHandler(btnAboutContainer) });
    btnAboutContainer.addEventListener('mouseleave', () => { endCursorHoverAnimation() });


}

function moveToCenterGallery(img) {
    centerFromTheBottom(img);

}


function putMainImageFullScreen() {

    canvas.style.filter = "blur(80px)";


}
const initImagesOverEffect = () => {
    list_main_images.forEach(elt => {
        elt.addEventListener('mouseenter', () => { mouseEnterImageHandler(elt) });

        elt.addEventListener('mouseleave', () => { endHoverMainImageAnimation(elt) });
    });
}
function initBtnHoverEffect() {
    btn_top.addEventListener('mouseenter', () => { mouseEnterBtnHandler(btn_top) });
    btn_top.addEventListener('mouseleave', () => { endCursorHoverAnimation() });

}
function removeImagesOverEffect() {
    imageHover = false;

}


function initOnClickImages() {

    img_anazir_container.addEventListener('click', function (e) {
        clickOnAnazir();
    });
    img_more_container.addEventListener('click', function (e) {
        clickOnMore();
    });
    img_mf_container.addEventListener('click', function (e) {

        clickOnMobileFood();
    });
    img_rn_container.addEventListener('click', function (e) {
        clickOnRetronews();
    });
}

function startCursorHoverAnimation(elt, factor) {

    const rect = elt.getBoundingClientRect();
    const rectCursor = cursor.getBoundingClientRect();
    const imageLeft = ((rect.left + 0.5 * rect.width)); // Account for any scrolling
    const imageTop = (rect.top + 0.5 * rect.height);   // Account for any scrolling

    // Move the cursor to the image's position
    cursor.animate({
        left: `${imageLeft}px`,
        top: `${imageTop}px`
    }, {
        duration: 500, fill: "forwards",
        easing: "cubic-bezier(0, 0.30, 0.19, 1)"
    }); // Adjust duration as needed

    var delay = 3;
    const size = Math.max(rect.width, rect.height);

    for (const child of cursor.querySelectorAll("svg")) {

        child.style.width = `${factor * size}px`;
        child.style.height = `${factor * size}px`;
        setTimeout(() => { child.style.animation = 'pulse ' + delay + 's ease-in-out infinite'; delay += 0.5 }, 300);


    }

    rotate_cursor(1);

}
function startCursorHoverLineAnimation(text) {
    document.body.style.cursor = "pointer";
    cursor.style.cursor = "pointer";
    cursor.setAttribute("deployed", true);

    cursor.querySelectorAll("svg").forEach((child, i) => {
        //child.style.height = `${factor * size}px`;
        child.style.width = `80px`;
        child.style.height = `80px`;
        var delay = 3;
        setTimeout(() => { child.style.animation = 'pulse ' + delay + 's ease-in-out infinite'; delay += 0.5 }, 300);
        if (i === 0) {
            child.style.fill = 'rgba(38, 38, 38, 1)';
        }

    });
    const span = cursor.querySelector("span");
    span.textContent = text;
    span.style.opacity = 1;

}


function startHoverMainImageAnimation(img) {
    startCursorHoverAnimation(img, 1.25);
    //showMobileFoodTextAnimation();
}
function endHoverMainImageAnimation(img) {

    endCursorHoverAnimation();

    // showNameAnimation();
}


function endCursorHoverAnimation() {
    for (const child of cursor.querySelectorAll("svg")) {
        //child.style.animation ="";
        child.style.height = "20px";
        child.style.width = "20px";
        child.style.animation = 'none ';
    }
    rotate_cursor(-1);
    cursorFollow = true;
}



const pointerMoveHandler = event => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

    if (cursorFollow === true && vw > 950) {

        const { clientX, clientY } = event;
        let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)

        var xForTBQT = (clientX / vw - 0.5) * 15;
        var yForTBQT = (clientY / vh - 0.5) * 15;
        tb_qt_1.animate({
            transform: `translate(${-xForTBQT}px,${yForTBQT}px)`,

            //margin: `${clientY}px`
        }, { duration: 1000, fill: "forwards" });
        tb_qt_2.animate({
            transform: `translate(${-xForTBQT}px,${-yForTBQT}px)`,


            //margin: `${clientY}px`
        }, { duration: 1000, fill: "forwards" });
        tb_qt_3.animate({
            transform: `translate(${xForTBQT}px,${-yForTBQT}px)`,


            //margin: `${clientY}px`
        }, { duration: 1000, fill: "forwards" });

        cursor.animate({
            left: `${clientX - 10}px`,
            top: `${clientY - 10}px`
        }, { duration: 500, fill: "forwards" });
    }

    if (getCanOpenProject()) {
        const projectSelected = router.actualRoute.props.projectSelected;
        if (projectSelected && cursor.getAttribute("deployed") === "false" && !aboutIsOpen)
            startCursorHoverLineAnimation("Open");
    }
    else {
        if (cursor.getAttribute("deployed") === "true")
            endCursorHoverLineAnimation();

    }

};



function mouseEnterImageHandler(elt) {
    if (imageHover) {
        cursorFollow = false;
        elt.style.cursor = "pointer";
        startHoverMainImageAnimation(elt);
    } else {
        elt.style.cursor = "auto";
    }

}
function mouseEnterBtnHandler(elt) {

    cursorFollow = false;
    startCursorHoverAnimation(elt, 1.25);

}


function showDetailsMobile() {
    detail_section.style.display = "flex";
    btnCloseProjectMobile.style.display = "block";
    centralElementsContainer.style.position = "relative";
    central_elements.style.position = "relative";
    centralElementsContainer.style.marginTop = "100px";
    //centralElementsContainer.style.marginBottom = "100px";
    centralElementsContainer.style.top = "0";


    mainImgSection.style.display = "none";
    aboutSection.style.display = "none";
    mainImgSection.style.display = "none";

    setTimeout(() => { detail_section.style.opacity = 1 }, 100);
    setTimeout(() => { btnCloseProjectMobile.style.opacity = 1 }, 100);


    centralElementsContainer.scrollIntoView(false);

}
function clickOnAnazir() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);


    majProjectData(2);

    if (vw < 950) {
        router.goForward('/anazir').then(() => {
            router.inTransition = false;
        });;

    }


}


function clickOnMore() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);


    majProjectData(1);

    if (vw < 950) {

        router.goForward('/repreneur').then(() => {
            router.inTransition = false;
        });;

    }
}

function clickOnMobileFood() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

    majProjectData(3);
    if (vw < 950) {

        router.goForward('/mobile-food').then(() => {
            router.inTransition = false;
        });;
    }



}

function clickOnRetronews() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    majProjectData(0);
    if (vw < 950) {
        router.goForward('/retronews').then(() => {
            router.inTransition = false;
        });;
    }
}



function replaceCentralElements() {
    central_elements.style.transition = "transform 1s cubic-bezier(.1,0,.10,1)"
    central_elements.style.transform = "translate(0, 0)";
}
function initAboutButtonFunction() {

    btnOpenAbout.addEventListener('click', openAbout);
    btnCloseAbout.addEventListener('click', closeAbout);

}


function hideAboutSection() {
    aboutSection.style.opacity = "0";
    setTimeout(() => { moveOutScreendown(aboutSection); }, 500);
}

function openAbout() {
    router.goForward("/about").then(() => {
        router.inTransition = false;
    });;
}
function closeAbout() {
    router.goForward("/").then(() => {
        router.inTransition = false;
    });;


}







function showGalleryDown() {

    if (router.canSwipe) {

        router.disableCanSwipeFor(1000);

        const oldSelected = router.actualRoute.props.imgSelected;


        if (oldSelected === 1) {
            router.actualRoute.props.imgSelected = 2;

            moveOutlineSelected(selector_2);
            goTop(img_mf_1);
            centerFromTheBottom(img_mf_2);
        }
        if (oldSelected === 2) {
            router.actualRoute.props.imgSelected = 3;

            moveOutlineSelected(selector_3);
            goTop(img_mf_2)
            centerFromTheBottom(img_mf_3);
        }
    }

}
function initSelectorClick() {
    selector_1.addEventListener('click', () => {
        const oldSelected = router.actualRoute.props.imgSelected;
        router.actualRoute.props.imgSelected = 1;
        if (oldSelected != 1) {
            moveOutlineSelected(selector_1);

            if (oldSelected === 3) {
                goBottom(img_mf_3);
                img_mf_2.style.transition = "none";
                moveOutScreendown(img_mf_2)
                centerFromTheTop(img_mf_1);

            }
            else {
                goBottom(img_mf_2);
                centerFromTheTop(img_mf_1);

            }
        }

    })


    selector_2.addEventListener('click', () => {
        const oldSelected = router.actualRoute.props.imgSelected;
        router.actualRoute.props.imgSelected = 2;
        selector_2.classList.add("selected");

        if (oldSelected != 2) {
            moveOutlineSelected(selector_2);

            if (oldSelected === 1) {
                goTop(img_mf_1);
                centerFromTheBottom(img_mf_2);
                selector_1.classList.remove("selected");

            }
            if (oldSelected === 3) {
                goBottom(img_mf_3);
                centerFromTheTop(img_mf_2);
                selector_3.classList.remove("selected");

            }
        }
    }
    )

    selector_3.addEventListener('click', () => {
        const oldSelected = router.actualRoute.props.imgSelected;
        router.actualRoute.props.imgSelected = 3;
        selector_3.classList.add("selected");


        if (oldSelected != 3) {
            moveOutlineSelected(selector_3);

            if (oldSelected === 1) {
                goTop(img_mf_1);
                img_mf_2.style.transition = "none";
                moveOutScreenUp(img_mf_2);
                centerFromTheBottom(img_mf_3);
                selector_1.classList.remove("selected");

            }
            else {
                goTop(img_mf_2);
                centerFromTheBottom(img_mf_3);
                selector_2.classList.remove("selected");

            }
        }


    })


}
function showGalleryUp() {

    if (router.canSwipe) {

        router.disableCanSwipeFor(1000)

        const oldSelected = router.actualRoute.props.imgSelected;


        if (oldSelected === 2) {
            router.actualRoute.props.imgSelected = 1;

            moveOutlineSelected(selector_1);
            goBottom(img_mf_2);
            centerFromTheTop(img_mf_1);
        }
        if (oldSelected === 3) {
            router.actualRoute.props.imgSelected = 2;

            moveOutlineSelected(selector_2);
            goBottom(img_mf_3);
            centerFromTheTop(img_mf_2);
        }
    }

}
function handleWheel(evt) {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw > 950 && getLoadedValue() === true) {
        // evt.preventDefault();
        const projectSelected = router.actualRoute.props.projectSelected;
        let delta;
        delta = -evt.deltaY * 40;
        // Ensure the delta is within a reasonable range
        delta = Math.min(Math.max(delta, -150), 150);
        if (delta < -100) {
            if (projectSelected === true && router.canSwipe) {


                nextProject();
                const idx = getIndexInFront();
                setTimeout(centralTextListFunction[idx], 300);
                majProjectData(idx);

            }
            else if (router.canSwipe === true) {

                showGalleryDown();

            }

        }
        if (delta > 100) {
            if (projectSelected === true && router.canSwipe) {
                previousProject();
                const idx = getIndexInFront();
                setTimeout(centralTextListFunction[idx], 300);
                majProjectData(idx);
            }
            else {
                if (router.actualRoute.props.imgSelected === 1 && router.canSwipe) {
                    closeDetailFunction();
                }
                else if (router.canSwipe) {
                    showGalleryUp();
                }
            }

        }
    }

}
const initScrollEvent = () => {
    document.addEventListener('wheel', handleWheel, { passive: false });
}
initScrollEvent()

function changeLetter(container, colPositions, letterHeight) {
    const colList = container.querySelectorAll("[class^=info-col]");

    for (var i = 0; i < colList.length; i++) {
        colList[i].style.transition = "transform 1s";
        const translateValue = colPositions[i] * letterHeight
        colList[i].style.transform = "translateY(" + translateValue + "px)";
    }

}


function handleClickChangeNameMovableButton(container, movablePositions, name) {
    //rotateCursorByAnim(45);
    let num = 0;
    indexList[name]++;
    const height = container.clientHeight;

    const index = indexList[name];
    const position = movablePositions[index % movablePositions.length];
    changeLetter(container, position, height);
}




function initMovable(line, movablePositions) {
    const positionTab = movablePositions[0];
    const containerMovable = line.querySelector(".info-movable")
    const height = containerMovable.clientHeight;
    changeLetter(containerMovable, positionTab, height);
}
function playAboutLineHoverAnimation(container, movablePositions, name) {
    let num = 0;
    const height = container.clientHeight;
    const originalIndexList = indexList[name];
    const originalPosition = movablePositions[originalIndexList % movablePositions.length];
    const colList = container.querySelectorAll("[class^=info-col]");

    for (var i = 0; i < colList.length; i++) {
        const newI = i;
        colList[i].style.transition = "transform 0.5s";
        colList[i].style.transform = i % 2 === 0 ? `translateY(${originalPosition[i] * height - 5}px)` : `translateY(${originalPosition[i] * height + 5}px)`;


    }
}
function unPlayAboutLineHoverAnimation(container, movablePositions, name) {
    let num = 0;
    const height = container.clientHeight;

    const originalIndexList = indexList[name];
    const originalPosition = movablePositions[originalIndexList % movablePositions.length];
    const colList = container.querySelectorAll("[class^=info-col]");

    for (var i = 0; i < colList.length; i++) {
        const newI = i;
        colList[i].style.transition = "transform 0.5s";

        colList[i].style.transform = i % 2 === 0 ? `translateY(${originalPosition[i] * height}px)` : `translateY(${originalPosition[i] * height}px)`;


    }
}
function initChangeBtn(line, movablePositions, name) {

    const containerMovable = line.querySelector(".info-movable")

    line.addEventListener('mouseenter', () => {
        playAboutLineHoverAnimation(containerMovable, movablePositions, name);
        // startCursorHoverLineAnimation("Change");
    })
    line.addEventListener('mouseleave', () => {
        aboutLineSelected = null;
        unPlayAboutLineHoverAnimation(containerMovable, movablePositions, name);
        //endCursorHoverLineAnimation();


    })
    line.addEventListener('click', () => { handleClickChangeNameMovableButton(containerMovable, movablePositions, name) })
    /*const changeBtn = line.querySelector(".change-btn");
   


    changeBtn.addEventListener('click', () => { handleClickChangeNameMovableButton(containerMovable, 50, movablePositions, name) });
    changeBtn.addEventListener('mouseenter', () => { mouseEnterBtnHandler(changeBtn) });
    changeBtn.addEventListener('mouseleave', () => { endCursorHoverAnimation() });*/

}

const initMobileCloseProjectBtnAction = () => {
    btnCloseProjectMobile.addEventListener("click", () => {
        router.goForward("/").then(() => {
            router.inTransition = false;
        });
    })
}


// Start the simulation
function simulateProgress() {
    let progress = 0;
    let unit = 0;
    let ten = 0;
    let hundred = 0;
    const interval = 800 / 100; // 4 seconds divided by 100 steps

    function incrementProgress() {
        updateLoader(unit, ten, hundred);

        progress++;
        unit++;
        if (progress <= 100) {
            if (unit === 10) {
                ten++;
                unit = 0;
            }
            if (ten === 10) {
                hundred++;
                ten = 0;
            }

            setTimeout(incrementProgress, interval);

        }
        else {
            loader.style.display = "none";
            setTimeout(showNameAnimation, 500);
            setTimeout(rotate_tbqt, 500);
            const projectIndex = router.actualRoute.props.projectIndex ? router.actualRoute.props.projectIndex : 0;
            majProjectData(projectIndex);
            app.style.opacity = 1;

            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            if (vw > 950) {
                initGalleryPosition();


                /* setTimeout(revealCaroussel, 1500);
                 setTimeout(showMobileFoodTextAnimation, 3000);
 
                 setTimeout(initBtnHoverEffect, 700);
                 setTimeout(initAboutButtonHover, 3500);
                 setTimeout(translateAboutBtn, 3500, 0);
                 majProjectData(getIndexInFront());
                 setTimeout(() => { document.body.addEventListener('mousemove', pointerMoveHandler); }, 100);*/
                initSelectorClick();
                setTimeout(() => {
                    router.render().then(() => {
                        router.inTransition = false;
                    });
                }, 500);
                setTimeout(initBtnHoverEffect, 500);
                setTimeout(() => { document.body.addEventListener('mousemove', pointerMoveHandler); }, 100);

                initAboutButtonHover();
                setCloseDetailBtnClick();
                //majProjectData(getIndexInFront());

            }
            else {
                setTimeout(initOnClickImages, 700);
                setTimeout(() => {
                    router.render().then(() => {
                        router.inTransition = false;
                    });
                }, 500);
            }


            // setTimeout(initImagesOverEffect, 700);


            setTimeout(initAboutButtonFunction, 700);

        }
    }

    incrementProgress();
}





initCol();

initMainImages();
simulateProgress();

initChangeBtn(nameLine, movableNamePositionTab, "name");
initChangeBtn(jobLine, movableJobPositionTab, "job");
initChangeBtn(useLine, movableUsePositionTab, "use");

initMovable(nameLine, movableNamePositionTab);
initMovable(jobLine, movableJobPositionTab);
initMovable(useLine, movableUsePositionTab);
initMobileCloseProjectBtnAction();
//ici
const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)





function handleScroll(event) {
    const inDetailPageMobile = router.actualRoute.id === 2 || router.actualRoute.id === 3 || router.actualRoute.id === 4 || router.actualRoute.id === 5;
    if (inDetailPageMobile === false) {
        var st = document.body.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        if (st > router.lastScrollTop) {
            for (const elt of list_main_images) {
                if (elt.getBoundingClientRect().top < 280) {
                    elt.style.transformOrigin = "center";
                    elt.style.transition = "opacity 0.25s";
                    //elt.style.opacity = "0";
                }
            }
        } else if (st < router.lastScrollTop) {
            for (const elt of list_main_images) {
                if (elt.getBoundingClientRect().top > 225) {
                    elt.style.transformOrigin = "center";

                    elt.style.transition = "opacity 0.25s";
                    //elt.style.opacity = "1";
                }
            }
        } // else was horizontal scroll
        router.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

        const mainImgSectionTopPos = mainImgSection.getBoundingClientRect().top;
        const aboutSectionTopPos = aboutSection.getBoundingClientRect().top;

        if (mainImgSectionTopPos < 300 && aboutSectionTopPos > 200) {
            showWorkTextAnimation();
        }
        else if (mainImgSectionTopPos > 300) {
            showNameAnimation()
        }

        if (aboutSectionTopPos < 200) {
            showAboutTextAnimation();
        }
    }


}
document.body.addEventListener("scroll", (event) => { handleScroll(event) })


document.addEventListener("keydown", (event) => {
    const projectSelected = router.actualRoute.props.projectSelected;
    const canSwipe = router.canSwipe;
    const imgSelected = router.actualRoute.props.imgSelected;
    //event.preventDefault();
    if (event.code === "ArrowUp") {

        if (projectSelected === true && canSwipe) {
            previousProject();
            const idx = getIndexInFront();
            setTimeout(centralTextListFunction[idx], 300);
            majProjectData(idx);
        }
        else {
            if (imgSelected === 1 && canSwipe) {
                closeDetailFunction();
            }
            else if (canSwipe) {
                showGalleryUp();
            }
        }

    }
    else if (event.code === "ArrowDown") {
        if (projectSelected === true && canSwipe) {


            nextProject();
            const idx = getIndexInFront();
            setTimeout(centralTextListFunction[idx], 300);
            majProjectData(idx);

        }
        else if (canSwipe === true) {

            showGalleryDown();

        }
    }
    else if (event.code === 'Enter') {
        if (projectSelected) {
            showDetailAnimation();
            setCloseDetailBtnClick();
        }

    }
    else if (event.code === 'Escape') {
        if (!projectSelected && canClose) {

            closeDetailFunction();
        }
        else if (aboutIsOpen) {
            closeAbout();
        }



    }
    else if (event.code === "Space") {
        revealCaroussel();
    }


});
function majProjectData(idx) {
    img_mf_1.src = "./images/" + projectDataList[idx].imagesFolder + "/1.png";
    img_mf_2.src = "./images/" + projectDataList[idx].imagesFolder + "/2.png";
    img_mf_3.src = "./images/" + projectDataList[idx].imagesFolder + "/3.png";

    imgSelector1.src = "./images/" + projectDataList[idx].imagesFolder + "/1_small.png";
    imgSelector2.src = "./images/" + projectDataList[idx].imagesFolder + "/2_small.png";
    imgSelector3.src = "./images/" + projectDataList[idx].imagesFolder + "/3_small.png";


    roleSpan.textContent = projectDataList[idx].role;
    stackSpan.textContent = projectDataList[idx].stack;
    typeSpan.textContent = projectDataList[idx].type;

    if (projectDataList[idx].link) {
        liveLink.parentElement.style.display = "flex";

        liveLink.href = projectDataList[idx].link

    }
    else {
        liveLink.parentElement.style.display = "none";
    }
}



async function showDetailAnimation() {
    //await mover.move(500, 200, 2000, 'easeInOut');
    const url = projectDataList[getIndexInFront()].url
    router.goForward(url).then(() => {
        router.inTransition = false;
    });
}
document.addEventListener("click", () => {
    const projectSelected = router.actualRoute.props.projectSelected;

    if (getCanOpenProject() && !aboutIsOpen && projectSelected === true) {
        showDetailAnimation();

    }
}

)

window.addEventListener("resize", () => {
    initMovable(nameLine, movableNamePositionTab);
    initMovable(jobLine, movableJobPositionTab);
    initMovable(useLine, movableUsePositionTab);
    const projectSelected = router.actualRoute.props.projectSelected;


    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw > 950) {
        if (!aboutIsOpen && projectSelected === true) {
            initGalleryPosition()
        }



    }

}

)
window.onpopstate = function (event) {
    if (event.state) {
        router.lastRoute = router.actualRoute;
        router.actualRoute = event.state;
    }

    router.render().then(() => {
        router.inTransition = false;
    });


};
